/* eslint-disable @typescript-eslint/return-await */
import { useCallback } from "react";

import { IPromiseProps } from "../components/PromisifiedDialog/PromisifiedDialog";
import { useCancellablePromisifiedDialog } from "./UseCancellablePromisifiedDialog";

export default function usePromisifiedDialog<DialogPropsT, ReturnedType = void>(
    PromisifiedDialod: React.ComponentType<
        IPromiseProps<ReturnedType> & DialogPropsT
    >
): (props: DialogPropsT) => Promise<ReturnedType> {
    const callCancellableModal = useCancellablePromisifiedDialog<
        DialogPropsT,
        ReturnedType
    >(PromisifiedDialod);

    return useCallback(
        async (props) => await callCancellableModal(props)[0],
        [PromisifiedDialod]
    );
}
